import { render, staticRenderFns } from "./ProfileBase.vue?vue&type=template&id=5855bc34&"
import script from "./ProfileBase.vue?vue&type=script&lang=js&"
export * from "./ProfileBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProfileBase.vue"
export default component.exports